<template>
  <section class="main-categories  container">
    <div class="main-categories__content  container-inner">
      <div class="main-categories__title">{{ $tHome('Categories') }}</div>
      <div class="main-categories__list">
        <template>
          <div v-for="item in itemsComputed"
               :key="item.id"
               :class="!item.active ? '_disabled' : null"
               class="main-categories__item">
            <router-link-modified v-if="item.active"
                                  :to="item.link"
                                  class="main-categories__item-content">
              <!--              <img src="../../assets/img/home/categories/1.svg"-->
              <!--                   :alt="createAltMixin(item.title)"-->
              <!--                   :title="createTitleMixin(item.title)"-->
              <!--                   class="main-categories__item-ico">-->
              <img :src="item.image"
                   :alt="createAltMixin(item.title)"
                   :title="createTitleMixin(item.title)"
                   class="main-categories__item-ico">
              <div class="main-categories__item-title">{{ item.title }}</div>
            </router-link-modified>
            <div v-else
                 class="main-categories__item-content">
              <img :src="item.image"
                   :alt="createAltMixin(item.title)"
                   :title="createTitleMixin(item.title)"
                   class="main-categories__item-ico">
              <h3 class="main-categories__item-title">{{ item.title }}</h3>
            </div>
          </div>
        </template>
      </div>

      <HomePageSectionVacanciesBtn :text="$tHome('All categories')"
                                   class="main-categories__btn"/>
    </div>
  </section>
</template>

<script>
  import {WINDOW_SIZE_MD} from '@/constants/windowSizes'
  import windowSizeMixin from '@/mixins/windowSizeMixin'
  import HomePageSectionVacanciesBtn from '@/components/homePage/common/HomePageSectionVacanciesBtn'

  export default {
    name: 'HomePageCategories',
    mixins: [
      windowSizeMixin
    ],
    components: {
      HomePageSectionVacanciesBtn
    },
    props: {
      items: {
        type: Array,
        required: true
      },
    },
    data() {
      return {}
    },
    computed: {
      itemsComputed() {
        if (this.windowSizeMixin.width <= WINDOW_SIZE_MD) {
          return this.items.slice(0, 6)
        }

        return this.items.slice(0, 8)
      }
    }
  }
</script>

<style lang="less">

</style>